import { render, staticRenderFns } from "./DesktopLayout.vue?vue&type=template&id=4c19f275&"
import script from "./DesktopLayout.vue?vue&type=script&lang=js&"
export * from "./DesktopLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports